import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import {
  CalculateMachineDurationSec,
  CalculateMachineDurationSecInOtherFormat,
} from "./DataNewFlowPage";
function convertTimeToLocal(date) {
  return moment.utc(date).local().toDate();
}
const CounterPage = React.memo(({ start, type, current }) => {
  // Always compute elapsed seconds from the real clock against `start`.
  // This way, if the component remounts (e.g. parent re-renders cause an
  // inline child to be re-created) the timer continues from the correct
  // elapsed time instead of resetting to a stale server snapshot.
  const computeElapsed = () => {
    if (!start) return 0;
    const startTime = convertTimeToLocal(start).getTime();
    const nowMs = Date.now();
    const diff = Math.floor((nowMs - startTime) / 1000);
    return diff > 0 ? diff : 0;
  };

  const [time, setTime] = useState(computeElapsed);

  // Recompute whenever `start` changes so the timer stays anchored to the
  // workflow start time (not reset on every render / node status update).
  useEffect(() => {
    setTime(computeElapsed());
    const interval = setInterval(() => {
      setTime(computeElapsed());
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start]);

  // ✅ Memoize the rendered component to prevent recalculation
  const DisplayComponent = useMemo(() => {
    if (type === "main") {
      return <CalculateMachineDurationSec Seconds={time + 1} />;
    }
    return <CalculateMachineDurationSecInOtherFormat Seconds={time} />;
  }, [type, time]);

  return <div>{DisplayComponent}</div>;
});

export default CounterPage;
